export const GetDaysFromSeconds = (value) => {
  const d = Math.floor(value / (3600 * 24));
  const h = Math.floor((value % (3600 * 24)) / 3600);
  const m = Math.floor((value % 3600) / 60);

  if (d > 0) {
    return `${d} ${d !== 1 ? "dias" : "dia"}`;
  }
  if (h > 0) {
    return `${h} ${h !== 1 ? "horas" : "hora"} e ${m} ${
      m !== 1 ? "minutos" : "minuto"
    }`;
  }
  return `${m} ${m !== 1 ? "minutos" : "minuto"}`;
};

export const GetDateToServer = (value) => {
  let result = value;

  if (
    result !== undefined &&
    result != null &&
    result.split("-").length === 3
  ) {
    const year = result.split("-")[0];
    const month = result.split("-")[1] - 1;
    const day = result.split("-")[2];

    result = new Date(year, month, day, 0, 0, 0, 0);

    result = result.toISOString();
  }

  return result;
};

export const GetSecondsBetweenDates = (lastTimeOut, lastTimeIn) => {
  const timeOut = new Date(lastTimeOut).getTime();
  const timeIn = new Date(lastTimeIn).getTime();

  return Math.abs((timeOut - timeIn) / 1000);
};
